import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAntigravity: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconAntigravity"><Path d="M20.5324 21.2328C21.7048 22.1122 23.4635 21.526 21.8514 19.9138C17.015 15.224 18.0409 2.32715 12.0321 2.32715C6.02333 2.32715 7.04921 15.224 2.21288 19.9138C0.45421 21.6725 2.35942 22.1122 3.53188 21.2328C8.07512 18.1552 7.782 12.7326 12.0321 12.7326C16.2822 12.7326 15.9891 18.1552 20.5324 21.2328Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAntigravity;
